import React from 'react';
import * as PropTypes from 'prop-types';
import BasicImage from '@itt/frontend-scaffold-components/dist/BasicImage/BasicImage';
import { Link } from '@material-ui/core';
import styles from './NavigationLinkItem.module.less';

const NavigationLinkItem = ({ icon, name, pathname, className }) => {
  return (
    <span className={`${styles.item} ${styles[className]}`}>
      <BasicImage src={icon} alt={icon} className={styles.icon} />
      <Link href={pathname} className={styles.name} underline='none'>
        {name}
      </Link>
    </span>
  );
};

NavigationLinkItem.propTypes = {
  icon: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired
};

export default NavigationLinkItem;
